// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file sidecar/v1/camera_local_api.proto (package sidecar.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sidecar/v1/camera_local_api.proto.
 */
export const file_sidecar_v1_camera_local_api: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message sidecar.v1.CameraInfo
 */
export type CameraInfo = Message<"sidecar.v1.CameraInfo"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;

  /**
   * @generated from field: string unique_id = 2;
   */
  uniqueId: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string driver_type = 4;
   */
  driverType: string;

  /**
   * @generated from field: string ip_address = 5;
   */
  ipAddress: string;

  /**
   * @generated from field: string manufacturer = 6;
   */
  manufacturer: string;

  /**
   * @generated from field: string model = 7;
   */
  model: string;

  /**
   * @generated from field: string firmware_version = 8;
   */
  firmwareVersion: string;

  /**
   * @generated from field: bool online = 9;
   */
  online: boolean;

  /**
   * @generated from field: bool has_ptz = 10;
   */
  hasPtz: boolean;

  /**
   * @generated from field: bool has_snapshot = 11;
   */
  hasSnapshot: boolean;

  /**
   * @generated from field: bool has_streaming = 12;
   */
  hasStreaming: boolean;

  /**
   * @generated from field: bool rtsp_enabled = 13;
   */
  rtspEnabled: boolean;

  /**
   * @generated from field: int32 rtsp_port = 14;
   */
  rtspPort: number;

  /**
   * @generated from field: bool http_enabled = 15;
   */
  httpEnabled: boolean;

  /**
   * @generated from field: int32 http_port = 16;
   */
  httpPort: number;

  /**
   * @generated from field: int32 channel_count = 17;
   */
  channelCount: number;

  /**
   * @generated from field: bool onvif_enabled = 18;
   */
  onvifEnabled: boolean;

  /**
   * @generated from field: int32 onvif_port = 19;
   */
  onvifPort: number;

  /**
   * @generated from field: string phase = 20;
   */
  phase: string;

  /**
   * @generated from field: string auth_error = 21;
   */
  authError: string;

  /**
   * @generated from field: string stream_profile = 22;
   */
  streamProfile: string;

  /**
   * @generated from field: bool has_floodlight = 23;
   */
  hasFloodlight: boolean;

  /**
   * @generated from field: bool has_siren = 24;
   */
  hasSiren: boolean;
};

/**
 * Describes the message sidecar.v1.CameraInfo.
 * Use `create(CameraInfoSchema)` to create a new message.
 */
export const CameraInfoSchema: GenMessage<CameraInfo> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 0);

/**
 * @generated from message sidecar.v1.ListCamerasRequest
 */
export type ListCamerasRequest = Message<"sidecar.v1.ListCamerasRequest"> & {
};

/**
 * Describes the message sidecar.v1.ListCamerasRequest.
 * Use `create(ListCamerasRequestSchema)` to create a new message.
 */
export const ListCamerasRequestSchema: GenMessage<ListCamerasRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 1);

/**
 * @generated from message sidecar.v1.ListCamerasResponse
 */
export type ListCamerasResponse = Message<"sidecar.v1.ListCamerasResponse"> & {
  /**
   * @generated from field: repeated sidecar.v1.CameraInfo cameras = 1;
   */
  cameras: CameraInfo[];
};

/**
 * Describes the message sidecar.v1.ListCamerasResponse.
 * Use `create(ListCamerasResponseSchema)` to create a new message.
 */
export const ListCamerasResponseSchema: GenMessage<ListCamerasResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 2);

/**
 * @generated from message sidecar.v1.GetCameraInfoRequest
 */
export type GetCameraInfoRequest = Message<"sidecar.v1.GetCameraInfoRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;
};

/**
 * Describes the message sidecar.v1.GetCameraInfoRequest.
 * Use `create(GetCameraInfoRequestSchema)` to create a new message.
 */
export const GetCameraInfoRequestSchema: GenMessage<GetCameraInfoRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 3);

/**
 * @generated from message sidecar.v1.GetCameraInfoResponse
 */
export type GetCameraInfoResponse = Message<"sidecar.v1.GetCameraInfoResponse"> & {
  /**
   * @generated from field: sidecar.v1.CameraInfo camera = 1;
   */
  camera?: CameraInfo;
};

/**
 * Describes the message sidecar.v1.GetCameraInfoResponse.
 * Use `create(GetCameraInfoResponseSchema)` to create a new message.
 */
export const GetCameraInfoResponseSchema: GenMessage<GetCameraInfoResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 4);

/**
 * @generated from message sidecar.v1.CameraPTZMoveRequest
 */
export type CameraPTZMoveRequest = Message<"sidecar.v1.CameraPTZMoveRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;

  /**
   * @generated from field: float pan = 2;
   */
  pan: number;

  /**
   * @generated from field: float tilt = 3;
   */
  tilt: number;

  /**
   * @generated from field: float zoom = 4;
   */
  zoom: number;

  /**
   * @generated from field: float speed = 5;
   */
  speed: number;
};

/**
 * Describes the message sidecar.v1.CameraPTZMoveRequest.
 * Use `create(CameraPTZMoveRequestSchema)` to create a new message.
 */
export const CameraPTZMoveRequestSchema: GenMessage<CameraPTZMoveRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 5);

/**
 * @generated from message sidecar.v1.CameraPTZMoveResponse
 */
export type CameraPTZMoveResponse = Message<"sidecar.v1.CameraPTZMoveResponse"> & {
};

/**
 * Describes the message sidecar.v1.CameraPTZMoveResponse.
 * Use `create(CameraPTZMoveResponseSchema)` to create a new message.
 */
export const CameraPTZMoveResponseSchema: GenMessage<CameraPTZMoveResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 6);

/**
 * @generated from message sidecar.v1.CameraPTZStopRequest
 */
export type CameraPTZStopRequest = Message<"sidecar.v1.CameraPTZStopRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;
};

/**
 * Describes the message sidecar.v1.CameraPTZStopRequest.
 * Use `create(CameraPTZStopRequestSchema)` to create a new message.
 */
export const CameraPTZStopRequestSchema: GenMessage<CameraPTZStopRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 7);

/**
 * @generated from message sidecar.v1.CameraPTZStopResponse
 */
export type CameraPTZStopResponse = Message<"sidecar.v1.CameraPTZStopResponse"> & {
};

/**
 * Describes the message sidecar.v1.CameraPTZStopResponse.
 * Use `create(CameraPTZStopResponseSchema)` to create a new message.
 */
export const CameraPTZStopResponseSchema: GenMessage<CameraPTZStopResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 8);

/**
 * @generated from message sidecar.v1.GetCameraSnapshotRequest
 */
export type GetCameraSnapshotRequest = Message<"sidecar.v1.GetCameraSnapshotRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;
};

/**
 * Describes the message sidecar.v1.GetCameraSnapshotRequest.
 * Use `create(GetCameraSnapshotRequestSchema)` to create a new message.
 */
export const GetCameraSnapshotRequestSchema: GenMessage<GetCameraSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 9);

/**
 * @generated from message sidecar.v1.GetCameraSnapshotResponse
 */
export type GetCameraSnapshotResponse = Message<"sidecar.v1.GetCameraSnapshotResponse"> & {
  /**
   * @generated from field: bytes jpeg_data = 1;
   */
  jpegData: Uint8Array;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;
};

/**
 * Describes the message sidecar.v1.GetCameraSnapshotResponse.
 * Use `create(GetCameraSnapshotResponseSchema)` to create a new message.
 */
export const GetCameraSnapshotResponseSchema: GenMessage<GetCameraSnapshotResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 10);

/**
 * @generated from message sidecar.v1.GetCameraStreamInfoRequest
 */
export type GetCameraStreamInfoRequest = Message<"sidecar.v1.GetCameraStreamInfoRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;
};

/**
 * Describes the message sidecar.v1.GetCameraStreamInfoRequest.
 * Use `create(GetCameraStreamInfoRequestSchema)` to create a new message.
 */
export const GetCameraStreamInfoRequestSchema: GenMessage<GetCameraStreamInfoRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 11);

/**
 * @generated from message sidecar.v1.StreamProfileInfo
 */
export type StreamProfileInfo = Message<"sidecar.v1.StreamProfileInfo"> & {
  /**
   * @generated from field: sidecar.v1.StreamProfile profile = 1;
   */
  profile: StreamProfile;

  /**
   * @generated from field: string video_codec = 2;
   */
  videoCodec: string;

  /**
   * @generated from field: int32 width = 3;
   */
  width: number;

  /**
   * @generated from field: int32 height = 4;
   */
  height: number;

  /**
   * @generated from field: int32 fps = 5;
   */
  fps: number;

  /**
   * @generated from field: bool transcoded = 6;
   */
  transcoded: boolean;
};

/**
 * Describes the message sidecar.v1.StreamProfileInfo.
 * Use `create(StreamProfileInfoSchema)` to create a new message.
 */
export const StreamProfileInfoSchema: GenMessage<StreamProfileInfo> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 12);

/**
 * @generated from message sidecar.v1.GetCameraStreamInfoResponse
 */
export type GetCameraStreamInfoResponse = Message<"sidecar.v1.GetCameraStreamInfoResponse"> & {
  /**
   * @generated from field: string video_codec = 1;
   */
  videoCodec: string;

  /**
   * @generated from field: int32 width = 2;
   */
  width: number;

  /**
   * @generated from field: int32 height = 3;
   */
  height: number;

  /**
   * @generated from field: int32 fps = 4;
   */
  fps: number;

  /**
   * @generated from field: int32 bitrate = 5;
   */
  bitrate: number;

  /**
   * @generated from field: repeated sidecar.v1.StreamProfileInfo profiles = 6;
   */
  profiles: StreamProfileInfo[];
};

/**
 * Describes the message sidecar.v1.GetCameraStreamInfoResponse.
 * Use `create(GetCameraStreamInfoResponseSchema)` to create a new message.
 */
export const GetCameraStreamInfoResponseSchema: GenMessage<GetCameraStreamInfoResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 13);

/**
 * @generated from message sidecar.v1.StartCameraStreamRequest
 */
export type StartCameraStreamRequest = Message<"sidecar.v1.StartCameraStreamRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;

  /**
   * @generated from field: string sdp_offer = 2;
   */
  sdpOffer: string;

  /**
   * @generated from field: int32 channel = 3;
   */
  channel: number;

  /**
   * @generated from field: sidecar.v1.StreamProfile stream_profile = 4;
   */
  streamProfile: StreamProfile;
};

/**
 * Describes the message sidecar.v1.StartCameraStreamRequest.
 * Use `create(StartCameraStreamRequestSchema)` to create a new message.
 */
export const StartCameraStreamRequestSchema: GenMessage<StartCameraStreamRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 14);

/**
 * @generated from message sidecar.v1.StartCameraStreamResponse
 */
export type StartCameraStreamResponse = Message<"sidecar.v1.StartCameraStreamResponse"> & {
  /**
   * @generated from field: string stream_id = 1;
   */
  streamId: string;

  /**
   * @generated from field: string stream_url = 2;
   */
  streamUrl: string;

  /**
   * @generated from field: string sdp_answer = 3;
   */
  sdpAnswer: string;
};

/**
 * Describes the message sidecar.v1.StartCameraStreamResponse.
 * Use `create(StartCameraStreamResponseSchema)` to create a new message.
 */
export const StartCameraStreamResponseSchema: GenMessage<StartCameraStreamResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 15);

/**
 * @generated from message sidecar.v1.StopCameraStreamRequest
 */
export type StopCameraStreamRequest = Message<"sidecar.v1.StopCameraStreamRequest"> & {
  /**
   * @generated from field: string stream_id = 1;
   */
  streamId: string;
};

/**
 * Describes the message sidecar.v1.StopCameraStreamRequest.
 * Use `create(StopCameraStreamRequestSchema)` to create a new message.
 */
export const StopCameraStreamRequestSchema: GenMessage<StopCameraStreamRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 16);

/**
 * @generated from message sidecar.v1.StopCameraStreamResponse
 */
export type StopCameraStreamResponse = Message<"sidecar.v1.StopCameraStreamResponse"> & {
};

/**
 * Describes the message sidecar.v1.StopCameraStreamResponse.
 * Use `create(StopCameraStreamResponseSchema)` to create a new message.
 */
export const StopCameraStreamResponseSchema: GenMessage<StopCameraStreamResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 17);

/**
 * @generated from message sidecar.v1.InitializeCameraRequest
 */
export type InitializeCameraRequest = Message<"sidecar.v1.InitializeCameraRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;
};

/**
 * Describes the message sidecar.v1.InitializeCameraRequest.
 * Use `create(InitializeCameraRequestSchema)` to create a new message.
 */
export const InitializeCameraRequestSchema: GenMessage<InitializeCameraRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 18);

/**
 * @generated from message sidecar.v1.InitializeCameraResponse
 */
export type InitializeCameraResponse = Message<"sidecar.v1.InitializeCameraResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;
};

/**
 * Describes the message sidecar.v1.InitializeCameraResponse.
 * Use `create(InitializeCameraResponseSchema)` to create a new message.
 */
export const InitializeCameraResponseSchema: GenMessage<InitializeCameraResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 19);

/**
 * @generated from message sidecar.v1.EnableCameraRTSPRequest
 */
export type EnableCameraRTSPRequest = Message<"sidecar.v1.EnableCameraRTSPRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;
};

/**
 * Describes the message sidecar.v1.EnableCameraRTSPRequest.
 * Use `create(EnableCameraRTSPRequestSchema)` to create a new message.
 */
export const EnableCameraRTSPRequestSchema: GenMessage<EnableCameraRTSPRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 20);

/**
 * @generated from message sidecar.v1.EnableCameraRTSPResponse
 */
export type EnableCameraRTSPResponse = Message<"sidecar.v1.EnableCameraRTSPResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;

  /**
   * @generated from field: bool rtsp_enabled = 3;
   */
  rtspEnabled: boolean;

  /**
   * @generated from field: int32 rtsp_port = 4;
   */
  rtspPort: number;
};

/**
 * Describes the message sidecar.v1.EnableCameraRTSPResponse.
 * Use `create(EnableCameraRTSPResponseSchema)` to create a new message.
 */
export const EnableCameraRTSPResponseSchema: GenMessage<EnableCameraRTSPResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 21);

/**
 * @generated from message sidecar.v1.EnableCameraHTTPRequest
 */
export type EnableCameraHTTPRequest = Message<"sidecar.v1.EnableCameraHTTPRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;
};

/**
 * Describes the message sidecar.v1.EnableCameraHTTPRequest.
 * Use `create(EnableCameraHTTPRequestSchema)` to create a new message.
 */
export const EnableCameraHTTPRequestSchema: GenMessage<EnableCameraHTTPRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 22);

/**
 * @generated from message sidecar.v1.EnableCameraHTTPResponse
 */
export type EnableCameraHTTPResponse = Message<"sidecar.v1.EnableCameraHTTPResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;

  /**
   * @generated from field: bool http_enabled = 3;
   */
  httpEnabled: boolean;

  /**
   * @generated from field: int32 http_port = 4;
   */
  httpPort: number;
};

/**
 * Describes the message sidecar.v1.EnableCameraHTTPResponse.
 * Use `create(EnableCameraHTTPResponseSchema)` to create a new message.
 */
export const EnableCameraHTTPResponseSchema: GenMessage<EnableCameraHTTPResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 23);

/**
 * @generated from message sidecar.v1.EnableCameraONVIFRequest
 */
export type EnableCameraONVIFRequest = Message<"sidecar.v1.EnableCameraONVIFRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;
};

/**
 * Describes the message sidecar.v1.EnableCameraONVIFRequest.
 * Use `create(EnableCameraONVIFRequestSchema)` to create a new message.
 */
export const EnableCameraONVIFRequestSchema: GenMessage<EnableCameraONVIFRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 24);

/**
 * @generated from message sidecar.v1.EnableCameraONVIFResponse
 */
export type EnableCameraONVIFResponse = Message<"sidecar.v1.EnableCameraONVIFResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;

  /**
   * @generated from field: bool onvif_enabled = 3;
   */
  onvifEnabled: boolean;

  /**
   * @generated from field: int32 onvif_port = 4;
   */
  onvifPort: number;
};

/**
 * Describes the message sidecar.v1.EnableCameraONVIFResponse.
 * Use `create(EnableCameraONVIFResponseSchema)` to create a new message.
 */
export const EnableCameraONVIFResponseSchema: GenMessage<EnableCameraONVIFResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 25);

/**
 * @generated from message sidecar.v1.SetFloodlightRequest
 */
export type SetFloodlightRequest = Message<"sidecar.v1.SetFloodlightRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: int32 brightness = 3;
   */
  brightness: number;
};

/**
 * Describes the message sidecar.v1.SetFloodlightRequest.
 * Use `create(SetFloodlightRequestSchema)` to create a new message.
 */
export const SetFloodlightRequestSchema: GenMessage<SetFloodlightRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 26);

/**
 * @generated from message sidecar.v1.SetFloodlightResponse
 */
export type SetFloodlightResponse = Message<"sidecar.v1.SetFloodlightResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;
};

/**
 * Describes the message sidecar.v1.SetFloodlightResponse.
 * Use `create(SetFloodlightResponseSchema)` to create a new message.
 */
export const SetFloodlightResponseSchema: GenMessage<SetFloodlightResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 27);

/**
 * @generated from message sidecar.v1.TriggerSirenRequest
 */
export type TriggerSirenRequest = Message<"sidecar.v1.TriggerSirenRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;

  /**
   * @generated from field: int32 times = 2;
   */
  times: number;
};

/**
 * Describes the message sidecar.v1.TriggerSirenRequest.
 * Use `create(TriggerSirenRequestSchema)` to create a new message.
 */
export const TriggerSirenRequestSchema: GenMessage<TriggerSirenRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 28);

/**
 * @generated from message sidecar.v1.TriggerSirenResponse
 */
export type TriggerSirenResponse = Message<"sidecar.v1.TriggerSirenResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;
};

/**
 * Describes the message sidecar.v1.TriggerSirenResponse.
 * Use `create(TriggerSirenResponseSchema)` to create a new message.
 */
export const TriggerSirenResponseSchema: GenMessage<TriggerSirenResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 29);

/**
 * @generated from message sidecar.v1.SnapshotTextOverlay
 */
export type SnapshotTextOverlay = Message<"sidecar.v1.SnapshotTextOverlay"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: sidecar.v1.SnapshotOverlayAnchor anchor = 2;
   */
  anchor: SnapshotOverlayAnchor;

  /**
   * @generated from field: int32 font_size_px = 3;
   */
  fontSizePx: number;

  /**
   * @generated from field: string color = 4;
   */
  color: string;
};

/**
 * Describes the message sidecar.v1.SnapshotTextOverlay.
 * Use `create(SnapshotTextOverlaySchema)` to create a new message.
 */
export const SnapshotTextOverlaySchema: GenMessage<SnapshotTextOverlay> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 30);

/**
 * @generated from message sidecar.v1.SnapshotImageOverlay
 */
export type SnapshotImageOverlay = Message<"sidecar.v1.SnapshotImageOverlay"> & {
  /**
   * @generated from field: bytes image_bytes = 1;
   */
  imageBytes: Uint8Array;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: sidecar.v1.SnapshotOverlayAnchor anchor = 3;
   */
  anchor: SnapshotOverlayAnchor;
};

/**
 * Describes the message sidecar.v1.SnapshotImageOverlay.
 * Use `create(SnapshotImageOverlaySchema)` to create a new message.
 */
export const SnapshotImageOverlaySchema: GenMessage<SnapshotImageOverlay> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 31);

/**
 * @generated from message sidecar.v1.SnapshotOverlayLayer
 */
export type SnapshotOverlayLayer = Message<"sidecar.v1.SnapshotOverlayLayer"> & {
  /**
   * @generated from oneof sidecar.v1.SnapshotOverlayLayer.layer
   */
  layer: {
    /**
     * @generated from field: sidecar.v1.SnapshotTextOverlay text = 1;
     */
    value: SnapshotTextOverlay;
    case: "text";
  } | {
    /**
     * @generated from field: sidecar.v1.SnapshotImageOverlay image = 2;
     */
    value: SnapshotImageOverlay;
    case: "image";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message sidecar.v1.SnapshotOverlayLayer.
 * Use `create(SnapshotOverlayLayerSchema)` to create a new message.
 */
export const SnapshotOverlayLayerSchema: GenMessage<SnapshotOverlayLayer> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 32);

/**
 * @generated from message sidecar.v1.TakeSnapshotRequest
 */
export type TakeSnapshotRequest = Message<"sidecar.v1.TakeSnapshotRequest"> & {
  /**
   * @generated from field: string camera_id = 1;
   */
  cameraId: string;

  /**
   * @generated from field: repeated sidecar.v1.SnapshotOverlayLayer layers = 2;
   */
  layers: SnapshotOverlayLayer[];
};

/**
 * Describes the message sidecar.v1.TakeSnapshotRequest.
 * Use `create(TakeSnapshotRequestSchema)` to create a new message.
 */
export const TakeSnapshotRequestSchema: GenMessage<TakeSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 33);

/**
 * @generated from message sidecar.v1.ChannelSnapshot
 */
export type ChannelSnapshot = Message<"sidecar.v1.ChannelSnapshot"> & {
  /**
   * @generated from field: int32 channel = 1;
   */
  channel: number;

  /**
   * @generated from field: bytes jpeg_data = 2;
   */
  jpegData: Uint8Array;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * @generated from field: string file_id = 4;
   */
  fileId: string;
};

/**
 * Describes the message sidecar.v1.ChannelSnapshot.
 * Use `create(ChannelSnapshotSchema)` to create a new message.
 */
export const ChannelSnapshotSchema: GenMessage<ChannelSnapshot> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 34);

/**
 * @generated from message sidecar.v1.TakeSnapshotResponse
 */
export type TakeSnapshotResponse = Message<"sidecar.v1.TakeSnapshotResponse"> & {
  /**
   * @generated from field: repeated sidecar.v1.ChannelSnapshot snapshots = 1;
   */
  snapshots: ChannelSnapshot[];
};

/**
 * Describes the message sidecar.v1.TakeSnapshotResponse.
 * Use `create(TakeSnapshotResponseSchema)` to create a new message.
 */
export const TakeSnapshotResponseSchema: GenMessage<TakeSnapshotResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_camera_local_api, 35);

/**
 * @generated from enum sidecar.v1.StreamProfile
 */
export enum StreamProfile {
  /**
   * @generated from enum value: STREAM_PROFILE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STREAM_PROFILE_SUB = 1;
   */
  SUB = 1,

  /**
   * @generated from enum value: STREAM_PROFILE_MAIN = 2;
   */
  MAIN = 2,
}

/**
 * Describes the enum sidecar.v1.StreamProfile.
 */
export const StreamProfileSchema: GenEnum<StreamProfile> = /*@__PURE__*/
  enumDesc(file_sidecar_v1_camera_local_api, 0);

/**
 * @generated from enum sidecar.v1.SnapshotOverlayAnchor
 */
export enum SnapshotOverlayAnchor {
  /**
   * @generated from enum value: SNAPSHOT_OVERLAY_ANCHOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SNAPSHOT_OVERLAY_ANCHOR_TOP_LEFT = 1;
   */
  TOP_LEFT = 1,

  /**
   * @generated from enum value: SNAPSHOT_OVERLAY_ANCHOR_TOP_RIGHT = 2;
   */
  TOP_RIGHT = 2,

  /**
   * @generated from enum value: SNAPSHOT_OVERLAY_ANCHOR_BOTTOM_LEFT = 3;
   */
  BOTTOM_LEFT = 3,

  /**
   * @generated from enum value: SNAPSHOT_OVERLAY_ANCHOR_BOTTOM_RIGHT = 4;
   */
  BOTTOM_RIGHT = 4,

  /**
   * @generated from enum value: SNAPSHOT_OVERLAY_ANCHOR_FULL_FRAME = 5;
   */
  FULL_FRAME = 5,
}

/**
 * Describes the enum sidecar.v1.SnapshotOverlayAnchor.
 */
export const SnapshotOverlayAnchorSchema: GenEnum<SnapshotOverlayAnchor> = /*@__PURE__*/
  enumDesc(file_sidecar_v1_camera_local_api, 1);

/**
 * @generated from service sidecar.v1.CameraLocalService
 */
export const CameraLocalService: GenService<{
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.ListCameras
   */
  listCameras: {
    methodKind: "unary";
    input: typeof ListCamerasRequestSchema;
    output: typeof ListCamerasResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.GetCameraInfo
   */
  getCameraInfo: {
    methodKind: "unary";
    input: typeof GetCameraInfoRequestSchema;
    output: typeof GetCameraInfoResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.CameraPTZMove
   */
  cameraPTZMove: {
    methodKind: "unary";
    input: typeof CameraPTZMoveRequestSchema;
    output: typeof CameraPTZMoveResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.CameraPTZStop
   */
  cameraPTZStop: {
    methodKind: "unary";
    input: typeof CameraPTZStopRequestSchema;
    output: typeof CameraPTZStopResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.GetCameraSnapshot
   */
  getCameraSnapshot: {
    methodKind: "unary";
    input: typeof GetCameraSnapshotRequestSchema;
    output: typeof GetCameraSnapshotResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.GetCameraStreamInfo
   */
  getCameraStreamInfo: {
    methodKind: "unary";
    input: typeof GetCameraStreamInfoRequestSchema;
    output: typeof GetCameraStreamInfoResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.StartCameraStream
   */
  startCameraStream: {
    methodKind: "unary";
    input: typeof StartCameraStreamRequestSchema;
    output: typeof StartCameraStreamResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.StopCameraStream
   */
  stopCameraStream: {
    methodKind: "unary";
    input: typeof StopCameraStreamRequestSchema;
    output: typeof StopCameraStreamResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.InitializeCamera
   */
  initializeCamera: {
    methodKind: "unary";
    input: typeof InitializeCameraRequestSchema;
    output: typeof InitializeCameraResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.EnableCameraRTSP
   */
  enableCameraRTSP: {
    methodKind: "unary";
    input: typeof EnableCameraRTSPRequestSchema;
    output: typeof EnableCameraRTSPResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.EnableCameraHTTP
   */
  enableCameraHTTP: {
    methodKind: "unary";
    input: typeof EnableCameraHTTPRequestSchema;
    output: typeof EnableCameraHTTPResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.EnableCameraONVIF
   */
  enableCameraONVIF: {
    methodKind: "unary";
    input: typeof EnableCameraONVIFRequestSchema;
    output: typeof EnableCameraONVIFResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.SetFloodlight
   */
  setFloodlight: {
    methodKind: "unary";
    input: typeof SetFloodlightRequestSchema;
    output: typeof SetFloodlightResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.TriggerSiren
   */
  triggerSiren: {
    methodKind: "unary";
    input: typeof TriggerSirenRequestSchema;
    output: typeof TriggerSirenResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.CameraLocalService.TakeSnapshot
   */
  takeSnapshot: {
    methodKind: "unary";
    input: typeof TakeSnapshotRequestSchema;
    output: typeof TakeSnapshotResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_sidecar_v1_camera_local_api, 0);

